
import TableList from "@components/templates/tablelist";
import { HttpAnalyzeDetailAll } from "@/service/fedex";
export default {
	mixins: [TableList],
	data() {
		return {
			isMixin: true,
			Tools: { show: true },
			Tabs: { show: true },
			formData: {},
			Searchs: {
				show: true,
				labelWidth: 110,
			},
			Plugins: { show: true },
			titles: [
				{ label: this.$t('fbb.analyze.titles1',{defaultValue:'总额差=FedEx账单总额-成本核算总额'}) },
				{ label: this.$t('fbb.analyze.titles2',{defaultValue:'基础费用差额=FedEx账单基础费用-成本核算基础费用'}) },
				{ label: this.$t('fbb.analyze.titles3',{defaultValue:'附加费用差额=FedEx账单附加费用-成本核算附加费用'}) }
			]
		}
	},
	methods: {
		ajaxRequest: HttpAnalyzeDetailAll,
		handleOperates(params = "", type, batch) {
			if (batch === true) {
				params = (params || this.checkedData.join(',')) + '';
				if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
			}
			switch (type) {
				case 'export':
					this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/expensesComparison/export', this.formData, {
						executor: 'request',
						download: true,
						method: 'get',
					})
					break;
			}
		},
	},
	computed: {
		//费用详情table
		ToolsData() {
			return [
				{
					name: this.$t('global.common.export',{defaultValue:'导出'}),
					operate: "export",
					theme: "info",
				},
			]
		},
		SearchsData() {
			return [
				{
					label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
					tag: 'vInput',
					key: 'EQ_invoiceNo',
					show: true,
				}, {
					label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
					tag: 'vDatepicker',
					style: "width:250px",
					key: 'BT_createdAt',
					show: true,
					props: {
						format: 'yy-mm-dd ~ yy-mm-dd',
						confirm: false,
					},
				},
				{
                    label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    more: true,
                    options: [
                        {value:'FedEx',label:'FedEx'},
                        {value:'UPS',label:'UPS'},
                    ],
                    props: {
                        filterable: true,
                    }
				},
				{
                    label: this.$t('fbb.analyze.iserrortype',{defaultValue:'是否异常'}),
                    tag: 'vSelect',
                    key: 'EQ_errorType',
                    more: true,
                    options: [
                        {value:'YES',label:this.$t('erp.global.yes',{defaultValue:'是'})},
                        {value:'NO',label:this.$t('erp.global.no',{defaultValue:'否'})},
                    ],
                    props: {
                        filterable: true,
                    }
                },
			]
		},
		columns() {
			return [
				{
					title: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
					key: 'invoiceNo',
				},
				// {
				// 	title: '承运商',
				// 	key: 'carrierCode',
				// },
				// {
				// 	title: '是否异常',
				// 	render(h,{row}){
				// 		switch(row.errorType){
				// 			case 'YES':return '是';break;
				// 			case 'NO':return '否';break;
				// 		}
				// 	}
				// },
				{
					title: this.$t('fbb.analyze.fedextotalnum',{defaultValue:'FedEx账单总数'})+"/"+this.$t('fbb.analyze.costtotalnum',{defaultValue:'成本核算总额'}),
					width: 180,
					render: (h, { row }) => {
						return <div>
							{row.fedexTotalExpenses}
							<div>{row.costTotalExpenses}</div>
						</div>
					}
				},
				{
					renderHeader: (h, params) => {
						return h('div', [
							h('vTooltip', {
								props: {
									placement: 'top',
									transfer: true,
									content: this.titles[0].label
								}
							}, [
								h('strong', this.$t('fbb.analyze.totaldifference',{defaultValue:'总额差'})),
								h('vIcon', {
									props: {
										type: "help-circle",
										color: "#ff9900",
										style: 'font-size:20px;'
									},
								}),
							]),


						])
					},
					key: 'totalDifference',
					render: (h, { row }) => {
						const val = row.totalDifference
						return val < 0 ? <div class='color-error' >{val}</div > : <div class='color-success' > {val}</div>
					}
				},
				{
					title: this.$t('fbb.analyze.fedexBaseCharges',{defaultValue:'FedEx账单'})+"/"+this.$t('fbb.analyze.costBaseCharges',{defaultValue:'成本核算基础费用'}),
					width: 180,
					render: (h, { row }) => {
						return <div>
							{row.fedexBaseCharges}
							<div>{row.costBaseCharges}</div>
						</div>
					}
				},
				{
					renderHeader: (h, params) => {
						return h('div', [
							h('vTooltip', {
								props: {
									placement: 'top',
									transfer: true,
									content: this.titles[1].label
								}
							}, [
								h('strong', this.$t('fbb.analyze.baseDifference',{defaultValue:'基础费用差额'})),
								h('vIcon', {
									props: {
										type: "help-circle",
										color: "#ff9900",
										style: 'font-size:20px;'
									},
								}),
							]),


						])
					},
					key: 'baseDifference',
					render: (h, { row }) => {
						const val = row.baseDifference
						return val < 0 ? <div class='color-error' >{val}</div > : <div class='color-success' > {val}</div>
					}
				},
				{
					title: this.$t('fbb.analyze.fedexBaseCharges',{defaultValue:'FedEx账单'})+"/"+this.$t('fbb.analyze.costAddenCharges',{defaultValue:'成本核算附加费用'}),
					width: 180,
					render: (h, { row }) => {
						return <div>
							{row.fedexAddenCharges}
							<div>{row.costAddenCharges}</div>
						</div>
					}
				},
				{
					renderHeader: (h, params) => {
						return h('div', [
							h('vTooltip', {
								props: {
									placement: 'top',
									transfer: true,
									content: this.titles[2].label
								}
							}, [
								h('strong', this.$t('fbb.analyze.addenDifference',{defaultValue:'附加费用差额'})),
								h('vIcon', {
									props: {
										type: "help-circle",
										color: "#ff9900",
										style: 'font-size:20px;'
									},
								}),
							]),


						])
					},
					key: 'addenDifference',
					render: (h, { row }) => {
						const val = row.addenDifference
						return val < 0 ? <div class='color-error' >{val}</div > : <div class='color-success' > {val}</div>
					}
				},
				{
					title: this.$t('erp.product_channel.currency',{defaultValue:'币种'}),
					width: 60,
					key: 'currency',
				},
				{
					title: this.$t('global.common.createdtime',{defaultValue:'创建时间'})+'/'+this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
					width: 130,
					render: (h, { row }) => {
						return <div>
							{row.createdAt}
							<div>{row.updatedAt}</div>
						</div>
					}
				},
			]
		},
	}
}
